//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.AMEBaseBuilder.js";
import "../AME/AME.SelectAMEBaseNode.js";
import "../no/SelectObject.js";
let d=[[[0,"AdPropertyData",1,"AME.ADPropertyData",0],[1,"SelectedEplanProperty",0,"AME.SelectAMEBaseNode",0]],[[["selectedEplanProperty","selectedADPropertyId","selectedADPropertyName","selectedADPropertyDataType"],"MapEplanPropertyToADLibraryObjectProperty",{},4,0],[[],"UnMapEplanProperty",{},0,0],[["selectedEplanValue","selectedADValue"],"MapEplanPropertyValueToAdPropertyValue",{},2,0],[["selectedADValue"],"UnMapEplanPropertyValue",{},1,0],[["selectedEplanValueListId","selectedEplanValueId","selAdValueName"],"MapEplanGlobalValues",{},3,0],[["selectedEplanValueId"],"UnmapEplanGlobalValue",{},1,0],[["selectedEplanValue"],"DeleteEplanPropertyValue",{},1,0]],[]];
SPLM.AME.ManageEplanGlobalMappingBuilder = class extends SPLM.AME.AMEBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.ManageEplanGlobalMappingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;